import styled from "styled-components";

interface Props {
  bannerType: string,
}

const JumbotronWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 70px;
  padding: 90px 60px 60px 60px;
  min-height: 512px;
  position: relative;

  @media screen and (max-width: 950px) {
    margin-top: 40px;
    min-height: 450px;
    padding: 90px 25px 60px 25px;
  }

  @media (max-width: 400px) {
    max-width: 100%;
    padding: 90px 25px 60px 25px;
  }
`;

const ImageBanner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 950px) {
    flex-direction: column;
  }
`;

const Banner = styled.img`
  @media only screen and (min-width: 950px) {
    display: ${(props: Props) => props.bannerType !== 'mobile' ? 'flex' : 'none' };
  }
  
  @media screen and (max-width: 950px) {
    display: ${(props: Props) => props.bannerType !== 'mobile' ? 'none' : 'flex' };
  }
`;

const LineBreak = styled.br``;

const Text = styled.p`
  font-size: 1.7rem;
  color: #333;
  text-align: left;
  line-height: 1.3;
  font-weight: bold;
  padding: 0 30px;

  @media screen and (min-width: 951px) {
    position: absolute;
    bottom: 90px;
    left: calc(50% - 470px);
  }

  @media screen and (max-width: 950px) {
    text-align: center;
    font-size: 1.5rem;
    line-height: 1.4;
  }
`;

export {
  JumbotronWrapper,
  ImageBanner,
  Banner,
  LineBreak,
  Text,
};
